import * as C from '../../actionTypes/rooms/list'

export const listRooms = () => ({type: C.LIST_ROOM})
export const changePage = (payload) => ({type: C.CHANGE_PAGE, payload})
export const changeTab = (payload) => ({type: C.CHANGE_TAB, payload})
export const submitSearch = () => ({type: C.SUBMIT_SEARCH})
